/*
  Campaigns Page
    - Scaffolding for Page
    - Handles modal open/close and which campaign is open


  Updated by Justin Chang on 8/25/2017
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Containers
import DowntimeDollarsBar from './containers/DowntimeDollarsBar';
import AvailableCampaigns from './containers/AvailableCampaigns';

class CampaignsPage extends Component {

  static propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    campaigns: PropTypes.array,
    setLoading: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { campaigns, setLoading } = this.props;

    if (campaigns)
      setLoading(false);

    // scroll to top of page
    window.scrollTo(0,0);

  }

  componentWillUpdate() {
    this.props.setLoading(false);

  }

  render() {
    return (
      <div>
        <DowntimeDollarsBar />
        <AvailableCampaigns
          onCardClick={(campaignId) => (
            this.props.history.push(`/app/campaigns/${campaignId}`)
          )}
        />
      </div>
    );
  }
}

export default CampaignsPage;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/Campaigns.js